var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg07Minzoku(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6A456D;}\n\t.st1{display:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,10h3h3h2v12h-2v2v4H8v-4H6v4H4v-4v-2H2V10H4z M10.2,3.9L7,0L3.8,3.9C2.7,4.2,2,4.7,2,5.3v0.9 c0,0.6,0.8,1.2,2.1,1.5C4.4,9,5.6,10,7,10s2.6-1,2.9-2.4C11.2,7.3,12,6.8,12,6.2V5.3C12,4.7,11.3,4.2,10.2,3.9z M24,22v-2h2v-8h-2 l0,0h-3h-3h-2v8h2v2l-4,6h4h2h2h2h4L24,22z M23.8,10H26l-2-4c0-0.8-1.3-1.5-3-1.5S18,5.2,18,6l-2,4h2.2c0.4,1.2,1.5,2,2.8,2 S23.4,11.2,23.8,10z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_px\\u5358\\u4F4D",
    className: "st1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg07Minzoku);
export default __webpack_public_path__ + "static/media/07_minzoku.c14ccf2a62f8557d8913f4e31edd74fa.svg";
export { ForwardRef as ReactComponent };